import { defineStore } from "pinia";
import { useProfile } from "~/store/profile";

type BannerResourceItem = {
  id: number;
  title: string;
  brands: string[];
  activation_date: string;
  expiration_date: string;
  created_at: string;
  updated_at: string;
};

type BannerData = {
  success: boolean;
  message: string;
  data: {
    banners: BannerResourceItem[];
  };
};

export const useBanner = defineStore("banners", () => {
  const bannersData = ref<BannerData | null>(null);
  const isFetching = ref(false);
  const profileStore = useProfile();

  const fetchBannerData = async () => {
    if (bannersData.value || isFetching.value) return;
    isFetching.value = true;

    const { data } = await useLazyFetch<BannerData>("/api/banners", {
      key: "cachedRequestBanners",
      method: "POST",
      body: {
        card_number: profileStore.profile.card_number,
      },
    });

    bannersData.value = data.value;
    isFetching.value = false;
  };

  const getBannersData = async () => {
    if (!bannersData.value) {
      await fetchBannerData();
    }

    return bannersData.value;
  };

  const banners = computed(() => {
    return bannersData.value?.data?.banners ?? [];
  });

  return {
    bannersData,
    isFetching,
    banners,
    fetchBannerData,
    getBannersData,
  };
});

